export enum OpportunityMembershipStatus {
  None = 'none',
  Waiting = 'waiting',
  Accepted = 'accepted',
  Rejected = 'rejected',
}
